import { cva, type VariantProps } from 'class-variance-authority'

export const statVariants = cva(
  'inline-flex items-center gap-2 bg-surface border border-line rounded-lg px-4 py-2.5 font-sans whitespace-nowrap',
  {
    variants: {
      color: {
        green: 'text-green',
        red: 'text-red',
        gold: 'text-gold',
        neutral: 'text-ink-3',
        accent: 'text-accent',
      },
    },
    defaultVariants: {
      color: 'neutral',
    },
  },
)

export type StatVariantProps = VariantProps<typeof statVariants>
